import { IReferral } from 'interfaces/Referral/IReferral';
import { http } from 'services/BaseApi';

export const getReferrals = async (userId: string): Promise<IReferral> => {
  return await http.get<IReferral>(`/referrals/${userId}`);
};
